export interface EventSlot {
  id: string;
  name: string;
  description: string;
  type: EventSlotType | null;
  status: EEventSlotStatus;
  startDate: Date;
  endDate: Date;
  duration: number;
  workerAccountId: string | null;
  quoteId: string | null;
  locations: EventSlotLocation[] | null;
  customer: EventSlotCustomer | null;
}

export interface EventSlotType {
  id: string;
  name: string;
}

export interface EventSlotLocation {
  countyName: string;
}

export interface EventSlotCustomer {
  quoteNumber: string;
  name: string;
  countyName: string;
}

export enum EEventSlotStatus {
  Available = "Available",
  Pending = "Pending",
  Busy = "Busy",
  Cancelled = "Cancelled",
  Expired = "Expired",
}

export interface EventSlotQueryParams {
  quoteId: string;
  page: number;
  pageSize?: number;
}

export interface ScheduleQuoteForm {
  quoteId: string;
  eventSlotId: string;
}